import { CDN_URL } from './src/services/config'

export default function imageLoader({ src, width, quality }) {
  return `${CDN_URL}${src}?w=${width}&q=${quality || 75}`
}
